import { Checkbox } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import { Stack } from 'commons/components';
import { useTranslationAccount } from 'domains/Account/hooks';

interface GeneralTaxProps {
  checked: boolean;
  taxRate: number;
  onCheckChange: (checked: boolean) => void;
  onTaxRateChange: (taxRate: number) => void;
  error: string | null;
}

function GeneralTax({
  checked,
  taxRate,
  onCheckChange,
  onTaxRateChange,
  error,
}: GeneralTaxProps) {
  const t = useTranslationAccount('businessDataPage.generalInformationCard');

  return (
    <Stack column align="stretch" spacing="tight">
      <Checkbox
        label={t('orderTaxesEnabled.label')}
        name="orderTaxesExceptions"
        checked={checked}
        onChange={(event) => onCheckChange(event.target.checked)}
      />
      {checked && (
        <FormField label={t('orderTaxesPercent.label')} id="orderTaxesPercent">
          <FormField.Input
            type="float"
            name="orderTaxesPercent"
            value={taxRate}
            onChange={(e) => onTaxRateChange(Number(e.target.value))}
            appendPosition="end"
            appearance={error ? 'danger' : 'none'}
          />
        </FormField>
      )}
    </Stack>
  );
}

export default GeneralTax;
